import { createSlice } from '@reduxjs/toolkit';
import paymentApi from 'src/api/payment';
import { PaymentMethodStatus } from 'src/enum/Status'; 

const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  reload: false,
  info: null,
  employeeList: null,
}

const slice = createSlice({
  name: 'payment_info',
  initialState,
  reducers: {
    setPaymentInfo(oldState, action) {
      const info = action.payload;
      oldState.info = info;
    },
    openModal(oldState) {
      oldState.isModalOpen = true;
    },

    closeModal(oldState) {
      oldState.isModalOpen = false;
      oldState.modalViewName = null;
      oldState.modalViewParams = null;
    },

    setModalViewName(oldState, action) {
      oldState.modalViewName = action.payload;
    },

    setEmployeeList(oldState, action) {
      oldState.employeeList = action.payload;
    },

    setModalViewParams(oldState, action) {
      oldState.modalViewParams = action.payload;
    },

    setReload(oldState, action) {
      oldState.reload = action.payload;
    }
  }
});

export const reducer = slice.reducer;

export const setPaymentInfo = (info) => (dispatch) => {
  
  dispatch(slice.actions.setPaymentInfo(info));
};

export const getPaymentMethodList =  () => async (dispatch) => {
  const info = await paymentApi.getPaymentMethodByStatus(PaymentMethodStatus.APPROVE,1)
  dispatch(slice.actions.getPaymentMethodList(info));
}

export const deletePaymentMethod =  (paymentId) => async (dispatch) => {

  const info = await paymentApi.softDeletePayment(paymentId);
}

export const setModalViewName = (viewName) => (dispatch) => {

  dispatch(slice.actions.setModalViewName(viewName));
};

export const setModalViewParams = (params) => (dispatch) => {

  dispatch(slice.actions.setModalViewParams(params));
}

export const setEmployeeList = (params) => (dispatch) => {

  dispatch(slice.actions.setEmployeeList(params));
}

export const openModal = () => (dispatch) => {

  dispatch(slice.actions.openModal());
};

export const closeModal = () => (dispatch) => {

  dispatch(slice.actions.closeModal());
};

export const setReload = (reload) => (dispatch) => {
  dispatch(slice.actions.setReload(reload))
}


export default slice;
